import auth from "@/api/model/auth"
import system from "@/api/model/system"
import tools from "@/api/model/tools"
import device from "@/api/model/device"

export default {
	auth,
	system,
	tools,
	device
}
